import { useEffect, useRef } from 'react';

// Hook de auto-refresh por polling (Fase 8), sem dependência de WebSocket.
// Chama `callback` a cada `intervaloMs` enquanto `ativo` for true.
// Usa um ref interno para sempre invocar a versão mais recente do callback,
// evitando recriar o intervalo a cada render. Pausa quando a aba não está
// visível, para não gastar requisições à toa.
export default function useAutoRefresh(callback, intervaloMs = 30000, ativo = true) {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    if (!ativo || !intervaloMs) return undefined;
    const tick = () => {
      if (typeof document !== 'undefined' && document.hidden) return;
      try { cbRef.current && cbRef.current(); } catch (_) {}
    };
    const id = setInterval(tick, intervaloMs);
    return () => clearInterval(id);
  }, [intervaloMs, ativo]);
}
